import Location from './location'
import { rapidReady } from '../../../../lib/utils/rapid'
import { generateUuid } from '../../../../lib/utils/uuid'

const LOCAL_STORAGE_LOCATION_KEY = 'location-list'
const LOCATION_URL = 'news-be/api/v1/user-locations/save'

export default (() => {
  class LocationController {
    constructor(elem) {
      this.elem = elem
      this.persistantStorage = this.getLocalStorage()
      this.locations = []
      this.isEditMode = false
      const { queryWoeid } = this.elem.dataset
      const currentWoeid = this.getCurrentCookieWoeid()
      if (this.persistantStorage && this.persistantStorage.length) {
        this.persistantStorage.forEach(location => {
          let currentHomeLoc = false
          let currentActiveLoc = false
          if (!Number(currentWoeid) && location.home === true && !queryWoeid) {
            currentHomeLoc = true
            currentActiveLoc = true
          }
          if (queryWoeid && Number(location.woeid) === Number(queryWoeid)) currentActiveLoc = true
          if (currentWoeid && Number(location.woeid) === Number(currentWoeid)) {
            currentHomeLoc = true
          }
          location.isHome = currentHomeLoc
          location.isUHomeLoc = location.isUHomeLoc || false
          location.isActive = currentActiveLoc
          this.locations.push(new Location({ ...location }))
        })
      }
    }

    addNewLocation(response, isNewLocation) {
      const { location } = response
      if (!this.locations.length) {
        this.locations.push(
          new Location({
            ...location,
            isActive: true,
            isHome: true,
            isUHomeLoc: !!this.weatherModule?.isChangeHome
          })
        )
      } else if (
        !this.locations.find(
          loc =>
            Number(loc.getPhotoWoeid) === Number(location.woeid) ||
            Number(loc.getWoeid) === Number(location.woeid)
        )
      ) {
        this.locations.forEach(v => {
          v.setInactive()
          if (v.isHome && this.weatherModule?.isChangeHome) {
            const woeid = Number(v.getWoeid)
            if (v.isHome && !v.isUHomeLoc) {
              v.removeHomeLocation()
              v.pill.remove()
              this.locations = this.locations.filter(loc => Number(loc.getWoeid) !== woeid)
            } else {
              v.removeHomeLocation()
            }
            this.currentActive = woeid
          }
        })
        this.locations.push(
          new Location({
            ...location,
            isActive: true,
            isHome: !!this.weatherModule?.isChangeHome,
            isUHomeLoc: !!this.weatherModule?.isChangeHome
          })
        )
        if (this.weatherModule.isSignedIn && this.weatherModule.enableSyncUserLoc) {
          this.saveLocations()
        }
      } else if (isNewLocation) {
        // this is to handle when user selects location that is already present
        this.locations.forEach(v => {
          if (v.getWoeid === location.woeid || Number(v.getPhotoWoeid) === Number(location.woeid)) {
            v.setActive()
            if (this.weatherModule?.isChangeHome) {
              v.setHomeLocation()
            }
          } else {
            v.setInactive()
            if (v.isHome && this.weatherModule.isChangeHome) {
              v.removeHomeLocation()
            }
          }
          if (this.weatherModule.isSignedIn && this.weatherModule.enableSyncUserLoc) {
            this.saveLocations()
          }
        })
      }
      this.syncStorage()
    }

    handleServerSidePill(container, weatherModule) {
      if (!container) return
      const pill = container.querySelector('.location-pill.active')
      if (pill) {
        if (weatherModule.isSignedIn && weatherModule.enableSyncUserLoc) {
          let pillLoc = []
          pillLoc = container.querySelectorAll('.location-pill')
          if (pillLoc.length) {
            const user_detected = pill?.classList.contains('home')
            const user_home_loc = pill?.classList.contains('user_home')

            if ((pillLoc.length === 1 && user_detected && user_home_loc) || pillLoc.length > 1) {
              this.locations = []
            }
            pillLoc.forEach(locObj => {
              const location = {
                isActive: !!locObj.classList.contains('active') || false,
                isHome: !!locObj.classList.contains('home') || false,
                isUHomeLoc: !!locObj.classList.contains('user_home') || false,
                display_name: locObj.innerText.split(',')[0],
                state: locObj.innerText.split(',')[1].trim(),
                woeid: locObj.dataset.key,
                photoWoeid: locObj.dataset.photoWoeid || ''
              }
              this.locations = this.locations.filter(
                loc => Number(loc.getWoeid) !== Number(locObj.dataset.key)
              )
              if (location.isUHomeLoc) {
                this.displayHomeDetectedIcon(locObj)
                this.locations.forEach(loc => {
                  if (loc.isUHomeLoc && loc.isHome) {
                    loc.setInactive()
                    loc.removeHomeLocation()
                  }
                })
              }
              this.locations.push(new Location(location, locObj))
            })
            if (pillLoc.length === 1 && user_detected && !user_home_loc) {
              this.saveLocations()
            }
          }
        } else {
          const btnLabel = pill.querySelector('.default-btn__label')
          let userHomeLocation = false
          this.locations
            .filter(v => v.isUHomeLoc && v.isHome)
            .forEach(v => {
              userHomeLocation = v.isUHomeLoc
            })
          const location = {
            isActive: true,
            isHome: true,
            isUHomeLoc: userHomeLocation || false,
            display_name: btnLabel.innerText.split(',')[0],
            state: btnLabel.innerText.split(',')[1].trim(),
            woeid: pill.dataset.key,
            photoWoeid: pill.dataset.photoWoeid || ''
          }

          this.locations = this.locations.filter(v => Number(v.getWoeid) !== Number(location.woeid))
          this.locations.push(new Location(location, pill))
          if (userHomeLocation) {
            this.displayHomeDetectedIcon(pill)
          }
        }
        // environment related edge case
        if (this.locations.length > 5) {
          while (this.locations.length > 5) {
            const index = this.locations.findLastIndex(v => !v.isHome && !v.isActive)
            this.locations.splice(index, 1)
          }
        }
      }
    }

    displayHomeDetectedIcon(pill) {
      pill?.querySelector('.detected-location')?.classList.add('display-hidden')
      pill?.querySelector('.home-location')?.classList.remove('display-hidden')
    }

    renderLocationPills(container, weatherModule) {
      if (!container) return
      this.weatherModule = weatherModule
      const locationLength = this.locations.length
      if (this.locations && locationLength) {
        const locationContainer = container.querySelector('.locations')
        this.locations.forEach(locationObj => {
          const locationPill = container.querySelector(`[data-key='${locationObj.getWoeid}']`)

          const locRapidConfig = {
            ll3: `location-${locationLength}`
          }

          if (locationObj.isHome && !locationObj.isUHomeLoc) {
            locRapidConfig.ll4 = 'home-detected'
            locRapidConfig.pos = 1
          } else if (locationObj.isUHomeLoc) {
            locRapidConfig.ll4 = 'home-selected'
            locRapidConfig.pos = 1
          }

          locationObj?.pill?.setAttribute('data-ylk', JSON.stringify(locRapidConfig))

          if (this.weatherModule.isMobileView && locationObj.getWoeid === this.currentActive) {
            locationObj.setActive()
            this.currentActive = -1
          }
          if (
            this.weatherModule.isMobileView &&
            this.weatherModule.isChangeHome &&
            locationObj.isActive &&
            !locationObj.isHome
          ) {
            locationObj.setInactive()
          }
          if (!locationPill) {
            locationContainer.appendChild(locationObj.pill)
            if (locationObj.pill.getAttribute('listener') !== 'true') {
              this.addEventListeners(locationObj)
            }
          } else if (locationObj.isHome) {
            // need to replace the server side pill, as it's instance is not same as what we have
            // in the serialized storage, plus it does not have click listeners
            locationPill.replaceWith(locationObj.pill)
            if (locationObj.pill.getAttribute('listener') !== 'true') {
              this.addEventListeners(locationObj)
            }
          } else if (
            this.weatherModule.isSignedIn &&
            this.weatherModule.enableSyncUserLoc &&
            !locationObj.isHome
          ) {
            locationContainer.appendChild(locationObj.pill)
            if (locationObj.pill.getAttribute('listener') !== 'true') {
              this.addEventListeners(locationObj)
            }
          }

          if (locationObj.hasCrossBtn) {
            locationObj.hideCrossBtn()
            locationObj.removeCrossBtnClass()
          }
        })
      } else if (this.weatherModule.hasCookie) {
        // there could be cookie set by default; this is where we handle that situation
        this.weatherModule.fetch({
          woeid: container.querySelector('.default-btn.primary').dataset.key
        })
      }
      this.isEditMode = false
      this.sortLocationPills(container)
    }

    renderMobilePills(container) {
      if (!container) return
      if (this.locations && this.locations.length) {
        const locationsContainer = container.querySelector('.locations')
        locationsContainer.innerHTML = ''
        this.locations
          .filter(v => v.isHome === false)
          .forEach(locationObj => {
            if (locationObj.isActive) this.currentActive = locationObj.getWoeid
            locationObj.showCrossBtn()
            locationObj.setInactive()
            locationObj.pill.classList.add('hasCrossBtn')
            locationsContainer.appendChild(locationObj.pill)
          })
      }
      this.isEditMode = true
    }

    addEventListeners(locationObj) {
      const { pill } = locationObj
      pill.addEventListener('click', () => {
        pill.setAttribute('listener', 'true')
        if (!this.isEditMode) {
          // set the pill as active
          this.locations.forEach(location => {
            location.setInactive()
          })
          locationObj.setActive()

          if (this.weatherModule.isChangeHome) {
            // change home location
            this.locations.forEach(v => v.removeHomeLocation())
            locationObj.setHomeLocation()
            this.weatherModule.fetch({ woeid: pill.dataset.key, noCookie: '' }, true)
            this.weatherModule.isChangeHome = false
            if (this.weatherModule.isSignedIn && this.weatherModule.enableSyncUserLoc) {
              this.saveLocations()
            }
          } else {
            this.weatherModule.fetch({ woeid: pill.dataset.key, noCookie: 'true' }, false)
          }
        } else if (this.isEditMode && !locationObj.isHome) {
          if (locationObj.getWoeid === this.currentActive) {
            // special case where you're trying to remove the current active
            this.locations.forEach(loc => {
              if (loc.isHome) {
                loc.setActive()
                // TODO: need to sync weather and new
                this.weatherModule.fetch({ woeid: loc.pill.dataset.key, noCookie: 'true' }, true)
              }
            })
          }
          if (
            this.isEditMode &&
            this.weatherModule.isChangeHomeClicked &&
            !this.weatherModule.isMobileView
          ) {
            this.weatherModule.isChangeHome = true
          }
          // remove from UI
          pill.remove()

          // remove from deserialized instance
          this.locations = this.locations.filter(
            location => Number(location.getWoeid) !== Number(pill.dataset.key)
          )
          if (this.weatherModule.isSignedIn && this.weatherModule.enableSyncUserLoc) {
            this.saveLocations()
          }

          this.weatherModule.tooltipHandler()
          if (this.weatherModule.isMobileView) {
            this.weatherModule.mHomeTooltipHandler()
          }
        }
        if (
          this.weatherModule.isMobileView &&
          (this.weatherModule.renderType === 'weather_v2' ||
            this.weatherModule.renderType === 'weather_channel_v2') &&
          this.weatherModule.isMobileModalVisible()
        ) {
          this.syncStorage()
        }
        this.addPillsIndex(locationObj)
      })
    }

    addPillsIndex(locationObj) {
      let counter = 1
      const locationObject = locationObj.location
      this.locations.sort((x, y) => {
        if (x.isHome) return -1
        if (y.isHome) return 1
        return 0
      })
      this.locations.forEach((obj, i) => {
        const locationName = obj.location.display_name
        if (locationName === locationObject.display_name) {
          counter = i + 1
        }
      })
      const ylk = {
        ...this.weatherModule.ylk,
        slk: `${locationObject.display_name}, ${locationObject.state.trim()}`,
        elmt: this.isEditMode ? 'remove-city' : 'saved-city',
        itc: 1,
        elm: 'location',
        sec: 'weather',
        pos: locationObj.isHome ? 1 : counter,
        ll3: `location-${this.locations.length}`
      }
      rapidReady(rapid => {
        rapid.beaconClick(ylk.sec, ylk.slk, ylk.itc, ylk)
      })
    }

    toggleCrossBtn() {
      this.locations.forEach(location => {
        if (location.isActive) {
          this.currentActive = location.getWoeid
          location.setInactive()
        }
        if (!location.isHome) {
          const crossBtn = location.pill.lastElementChild
          crossBtn?.classList.toggle('display-hidden')
          location.pill.classList.toggle('hasCrossBtn')
        }
      })
      this.isEditMode = !this.isEditMode

      if (!this.isEditMode) {
        this.locations.forEach(location => {
          if (location.getWoeid === this.currentActive) {
            location.setActive()
          }
        })
      }
    }

    sortLocationPills(container) {
      this.locations.sort((x, y) => {
        if (x.isHome) return -1
        if (y.isHome) return 1
        return 0
      })
      const locationsContainer = container.querySelector('.locations')
      locationsContainer.innerHTML = ''
      this.locations.forEach(v => {
        locationsContainer.appendChild(v.pill)
      })
    }

    syncStorage() {
      this.persistantStorage = []
      this.locations.forEach(locationObj => {
        this.persistantStorage.push(locationObj.location)
      })
      this.setLocalStorage(this.persistantStorage)
    }

    setLocalStorage(value) {
      const stringified = JSON.stringify(value)
      const base64Encoded = window.btoa(stringified)
      window.localStorage.setItem(LOCAL_STORAGE_LOCATION_KEY, base64Encoded)
    }

    sanitizeLocalStorage(lsObj) {
      const filterLsObject = lsObj.filter(loc => !!loc.woeid)
      if (filterLsObject.length !== lsObj.length) {
        this.setLocalStorage(filterLsObject)
      }
      return filterLsObject
    }

    getLocalStorage() {
      const lsString = window.localStorage.getItem(LOCAL_STORAGE_LOCATION_KEY)
      let lsObj = null
      if (!lsString) {
        return lsObj
      }

      try {
        const json = window.atob(lsString)
        lsObj = JSON.parse(json)
        lsObj = this.sanitizeLocalStorage(lsObj)
      } catch (e) {
        // failed to read LS, clean up the corrupt memory
        window.localStorage.removeItem(LOCAL_STORAGE_LOCATION_KEY)
      }

      return lsObj
    }

    get isMaxLocation() {
      return this.locations.length >= 5
    }

    fetchCookie(name) {
      const a = `; ${document.cookie}`.match(`;\\s*${name}=([^;]+)`)
      return a ? a[1] : ''
    }

    syncUserLocationData() {
      const locationSyncObject = this.locations
        .filter(
          v => v.location.country_code === 'US' || !(v.location.isHome && !v.location.isUHomeLoc)
        )
        .map(locaObj => ({
          city: locaObj?.location.display_name,
          state: locaObj?.location.state,
          isHome: locaObj?.location.isUHomeLoc || false,
          zipCode: ''
        }))
      return locationSyncObject
    }

    async saveLocations() {
      const data = this.syncUserLocationData()
      try {
        const url = `/${LOCATION_URL}`
        const options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-rid': `web-${generateUuid()}`
          },
          body: JSON.stringify({ locations: data })
        }
        await fetch(url, options)
      } catch (error) {
        console.error(error)
      }
    }

    getCurrentCookieWoeid() {
      let currentWoeid
      try {
        return decodeURI(this.fetchCookie('weathergeo'))
          .replace(/['"]+/g, '')
          .split('|')
          .splice(-1)[0]
      } catch (e) {
        return currentWoeid
      }
    }
  }
  return LocationController
})()
